import React from 'react'
import RegistryUrl from '../registry.url'

const License = ({license, isAccountDefault}) => {
    const Icon = ()=>(
        license.hasExclusion?
            <i className="fa fa-check-circle fa-lg" style={{color:"lightgray"}}></i>
            :
            <React.Fragment>
                {
                    license.hasWarning?
                        <i className={"fa fa-question-circle " +  iconDimension} style={{color:"orange"}}></i>:null
                }
                {
                    license.hasViolation?
                        <i className={"fa fa-exclamation-circle " + iconDimension} style={{color:"red"}}></i>:null
                }
                {
                    !license.hasWarning && !license.hasViolation?
                        <i className="fa fa-check-circle fa-lg" style={{color:"green"}}></i>:null
                }
            </React.Fragment>
    )
    const License = ()=>(
        <a href={license.uri} target="_blank" className="ml-3" rel="noopener noreferrer">
            {license.wildcard?license.name:license.id}
        </a>
    )
    
    
    const Description = ()=>{
        const policies = []
        
        return license.exclusions.length && license.exclusions[0]?
            <React.Fragment>
                <div className="vspacer10"></div>
                {license.exclusions[0].description}
                <div className="vspacer10"></div>
            </React.Fragment>
            :
            <React.Fragment>
                {license.violations.map((violation,index)=>{
                    if(policies.includes(violation.policyName)) return null
                    policies.push(violation.policyName)
                    return(
                        <p className="h5 mt-3 mb-3" key={"violation"+index}><strong>
                            <span className="hspacer50">&nbsp;</span>
                            License denied due to the policy &quot;{violation.policyName}&quot;.
                        </strong></p>
                       ) 
                })
                }
                {
                    license.warnings?
                    <p className="h5 mt-3 mb-3"><strong>
                        <span className="hspacer50">&nbsp;</span>
                        {license.warnings}
                    </strong></p>
                    :null
                }
            </React.Fragment>
        
    }
    


    const iconDimension = isAccountDefault? "fa-lg" : "fa-3x";
    return(
        <div key={license.id} className="license-library">
            <Icon />
            <License />
            <Description />
        </div>
    )
}

const Library = ({license,language, findDependencyInTree}) => {


    const Libraries = ()=>(
        license.results.map(({library, version},i)=>{

            const LibraryWithLink = ()=>(
                <React.Fragment key={library.name+"-"+i}>
                        <div className="badge badge-light btn-light pointer" value="" title="See in dependency tree" 
                            tabIndex={0}
                            onClick={()=>findDependencyInTree(language, library)}
                            onKeyUp={(e)=>findDependencyInTree(language, library, {key: e.key})} >{library.displayName}</div>
                        <RegistryUrl name={library.name} version={version} language={language} />
                    
                    {	library.otherLicenses?
                        <React.Fragment>(
                        
                        {
                            library.otherLicenses.map(other=>{
                                const {wildcard,name,id,uri}=other;
                                return <a href={uri} target="_blank" className="m-1" rel="noopener noreferrer">
                                    {
                                        wildcard?name:id
                                    }
                                    </a>
                            })
                        }
                        )
                        </React.Fragment>
                        :null
                    }
                    <br/>
                </React.Fragment>
            )


            return(
                <LibraryWithLink   key={library.name+"-fragment"+i}/>
            )
        })
    )




    return(
        <div className="license-name">
            <Libraries />
        </div>
    )
}

const LegalView = (props) =>{
    

    
    
    const legalLicenses=props.licensing.section.legal;
    return legalLicenses.map((report,index)=>{
    
    
        // if(props.toggledLanguages.includes(report.language)) return "";
        return(
            <div data-language={report.language} key={report.language} className="mb-5">
                <div className="license-wrapper version-title">
                    <div className="license-library"><b>Licenses ({report.language})</b></div>
                    <div className="license-name"><b>Libraries</b></div>
                </div>
                {  	
                    report.licenses.map((license, indexA)=>{
                        return(
                            <div className="license-wrapper" data={indexA} key={"legal"+report.language+index+""+indexA}>
                                <License license={license} />
                                <Library license={license} language={report.language} findDependencyInTree={props.findDependencyInTree} />
                            </div>
                        )
    
                    })
                    
                }
                <div className="license-wrapper"></div>
            </div>
        )
    })

}


export default LegalView